/**
 * The existing quotation named in `create_supplier_quotation`'s duplicate refusal (2026-09-19):
 *
 *     Supplier Quotation SQ-2026-00387 already exists for RFQ RFQ-2026-00105 and Enquiry
 *     ENQ-2026-00238. Cannot create a duplicate.
 *
 * One draft per RFQ and enquiry is the server's rule, and `update_supplier_quotation` fails the
 * same check against the document itself — so a quotation filed wrong (rate 0.00 from a parser
 * that could not read the workbook, ENQ-2026-00238) could not be corrected at all. Measured the
 * same day: a DRAFT can be deleted through `/api/resource/Supplier Quotation/<name>` (202), and
 * the reply filed again. The panel offers exactly that, naming the document it will discard.
 */
export function duplicateSupplierQuotationOf(message: string): string | null {
  const m = /Supplier Quotation (SQ-\d{4}-\d+) already exists/i.exec(message)
  return m ? m[1] : null
}
